import { IGenericJSON } from '../helpers/interface';
import { JobListing } from './job-listing';
import { Post } from './post';

export class Career {
  id: number;
  name: string;
  tagline: string;
  career_type_id: number;
  icon: string;
  description: string;
  banner: any;
  salary: string;
  status: string;
  required_education: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  JobListings: JobListing[];
  skills: any[];
  CareerMedia: any[];
  LinkedPosts: Post[];
  RelatedCareerPages: Career[];

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.name = data['name'];
    this.tagline = data['tagline'];
    this.career_type_id = data['career_type_id'];
    this.icon = data['icon'];
    this.description = data['description'];
    this.status = data['status'];
    this.banner = data['banner'];
    this.salary = data['salary'];
    this.required_education = data['required_education'];
    this.createdAt = new Date(data['createdAt']);
    this.updatedAt = new Date(data['updatedAt']);
    this.JobListings = data['JobListings'];
    this.CareerMedia = data['CareerMedia'];
    this.skills = data['skills'];
    this.LinkedPosts = data['CareerPost'];
    this.RelatedCareerPages = data['RelatedCareerPages'];
  }

  public static digest(data: IGenericJSON): Career {
    return new Career(data);
  }

  public static digestResponse(data: IGenericJSON[]): Career[] {
    const ret: Career[] = [];

    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });

    return ret;
  }
}
